document.addEventListener('DOMContentLoaded', function() {
    const elements = document.querySelectorAll('.perf');
    elements.forEach(checkForContentVisibility);

    function checkForContentVisibility(el) {
        const observer = new IntersectionObserver(
            function(entries) {
                entries.forEach(function(entry) {
                    if(entry.isIntersecting) {
                        entry.target.classList.remove('perf');

                        observer.disconnect();
                    }
                });
            },
            {
                root: null,
                rootMargin: '50px',
                threshold: [0, 1],
            }
        );

        observer.observe(el);
    }

    window.checkForContentVisibility = checkForContentVisibility;
});
